import { ResponsiveDescription } from './pageDescription.style';
import type { PageDescriptionProps } from '../../types';

/**
 * ResponsivePageDescription
 *
 * Responsive variant of `PageDescription`. Font sizes adapt per breakpoint via
 * `RESPONSIVE_DESCRIPTION_SIZES` from the sales-checkin-components constants,
 * which derives every value from the ui-bricks typography scale — no hardcoded
 * values anywhere:
 *   • Desktop / Tablet (default / ≤ 1279px)  →  20px  (HEADING_SIZE[5])
 *   • Mobile           (≤ 767px)              →  16px  (HEADING_SIZE[7])
 */
export const ResponsivePageDescription = ({ children, 'data-testid': dataTestId = 'page-description' }: PageDescriptionProps) => (
    <ResponsiveDescription level={5} weight="regular" data-testid={dataTestId}>
        {children}
    </ResponsiveDescription>
);

export default ResponsivePageDescription;
